module.exports = __webpack_public_path__ + "static/media/360dude.b228aaf0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/01/01/assets/360dude.svg
// module id = 351
// module chunks = 0